import "./featuredViva.scss"
import React, { useEffect, useState } from 'react';
import { getCurrentTerm} from '../../services/termService';

export const FeaturedViva = () => {

  const [term, setTerm] = useState(null);
  const fetchTerm = async () => {
      try {
          const data = await getCurrentTerm();
         // console.log(data);
          const termData = data.data;
          if (termData && termData.name == 'Term IV') {
          termData.phase = 'Phase 1';
          }

          if (termData && termData.name == 'V') {
          termData.phase = 'Phase 2';
          }

          if (termData && termData.name == 'VI') {
          termData.phase = 'Phase 3';
          }

          setTerm(termData);
      } catch (err) {
          
      } 
  };
  useEffect(() => {      

      fetchTerm();
  }, []);

  const pdfFiles = [
    { name: 'Session 1', url: '/pdfs/session1.pdf' },
    { name: 'Session 2', url: '/pdfs/brochure.pdf' },
    { name: 'Session 3', url: '/pdfs/brochure.pdf' },
  ];

  const recordingFiles = [
    { name: 'Session 1', url: 'https://drive.google.com/file/d/1sTisNtlYJRIs1u6vgi3bln91GZLnFELx/view?usp=sharing' },
    { name: 'Session 2', url: '/pdfs/brochure.pdf' },
    { name: 'Session 3', url: '/pdfs/brochure.pdf' },
  ];

  const handlePDFSelect = (event) => {
    const selectedPdf = event.target.value;
    if (selectedPdf) {
      window.open(selectedPdf, '_blank'); // Opens the PDF in a new tab
    }
  }

  return (
    <div className="featuredViva">
 

      <div className="details">
        <h2>Current Term( <span style={{ color: 'red' }}>{term && term.name + '-' + term.phase}</span> ) Feedback/Evaluation details</h2>
        <ul className="pdf-list">

          <li>
            Project Proposal Evaluation Feedback Dates: <span style={{ color: 'red' }}>{'6th - 10th October, 2025'}</span>
          </li>
          <li>
            Project Proposal Evaluation Plan : <span style={{ color: 'red' }}>{'Offline evaluation with recorded video'}</span>
          </li>
          {term?.name === 'Term IV' && (
          <li>
            End Term Report Evaluation Dates : <span style={{ color: 'red' }}>{'15th - 20th December, 2025'}</span>
          </li>
          )}
          {term?.name === 'Term IV' && (
          <li>
            End Term Report Evaluation Plan : <span style={{ color: 'red' }}>{'Online Viva'}</span>
          </li>
          )}
          <li>
  Examiners List and Viva Schedules:{" "}
  <a
    href="https://docs.google.com/spreadsheets/d/1cGaRtJMhEqE-Nw7AS0aEFQWTNWg-efsVVdbObL0OikE/edit?usp=sharing"
    target="_blank"
    rel="noopener noreferrer"
    style={{ color: 'red', textDecoration: 'underline' }}
  >
    Click here
  </a>
</li>
        </ul>
      </div>



    </div>
  )
}
